import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Header/Navbar';
import BacktestCta from './components/BacktestCta/BacktestCta';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Sentiment from './pages/Sentiment/Sentiment';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';
import Imprint from './pages/Imprint/Imprint';
import DataProtection from './pages/DataProtection/DataProtection';
import NotFound from './pages/NotFound/NotFound';
import CookieConsent from './components/CookieConsent/CookieConsent';

// Wrapper component that provides language context
const LanguageRoutes = () => {
  return (
    <LanguageProvider>
      <div className="app">
        <Navbar />
        <div className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sentiment" element={<Sentiment />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/dataprotection" element={<DataProtection />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <BacktestCta />
        <Footer />
        <CookieConsent />
      </div>
    </LanguageProvider>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Redirect root to default language */}
          <Route path="/" element={<Navigate to="/de" replace />} />

          {/* Language-specific routes */}
          <Route path="/:lang/*" element={<LanguageRoutes />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
